import { ErrorCode, getApiErrorCode } from '@/common/error';
import { i18n } from '@/plugins/i18n';

const VOICE_AI_I18N_PREFIX = 'page.connect.overloaded.voice_ai';

export const VOICE_AI_GENERIC_ERROR_KEY = `${VOICE_AI_I18N_PREFIX}.generic_error`;

/** Add new voice-ai/new-chat error codes here with a matching en.json key. */
const VOICE_AI_ERROR_CODE_TO_I18N_KEY: Partial<Record<ErrorCode, string>> = {
  [ErrorCode.VOICE_AI_TEMPORARILY_UNAVAILABLE]: `${VOICE_AI_I18N_PREFIX}.temporarily_unavailable`,
};

export const resolveVoiceAiApiErrorMessage = (error?: unknown): string => {
  const code = getApiErrorCode(error);
  const i18nKey = code !== undefined ? VOICE_AI_ERROR_CODE_TO_I18N_KEY[code as ErrorCode] : undefined;

  if (!i18nKey) {
    return i18n.t(VOICE_AI_GENERIC_ERROR_KEY) as string;
  }

  return i18n.t(i18nKey) as string;
};
